var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bar d-none"},[_c('v-btn',{staticClass:"mx-1",attrs:{"height":"46","color":"primary","title":"Gérer mon status"}},[_c('v-icon',{attrs:{"color":""}},[_vm._v("mdi-thought-bubble-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }